module.exports = __webpack_public_path__ + "img/G.4c14efac.gif";